import appConfigStoreModule from '@core/@app-config/appConfigStoreModule'
import Vue from 'vue'
import Vuex from 'vuex'
import app from './app'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: null,
    cvData: {}, // Initialize cvData in the store's state
  },
  mutations: {
    User(state, user) {
      state.user = user
    },
    SET_CV_DATA(state, cvData) {
      state.cvData = cvData
    },
  },
  actions: {
    User({ commit }, user) {
      commit('User', user)
    },
    saveCvDataToStore({ commit }, cvData) {
      commit('SET_CV_DATA', cvData)
      // console.log('store:', cvData)
      // You can add additional logic here, like saving to localStorage or an API
    },
  },
  getters: {
    User(state) {
      return state.user
    },
    getCvData(state) {
      return state.cvData
    },
  },
  modules: {
    appConfig: appConfigStoreModule,
    app,
  },
})
